export enum SynchronizationStatus {
  Progress = 'inProgress',
  Success = 'success',
  Error = 'error',
}
